import React from 'react'
import PropTypes from 'prop-types'

const hazardousFields = ['signalWord', 'warning', 'safetyInstructions', 'additionalCharacteristics']

const HazardousText = ({ hazardInfo, translationMapping }) => {
  return hazardousFields
    .filter(field => hazardInfo[field])
    .map(field => (
      <div key={field}>
        <div className='bold'>{translationMapping[field]}</div>
        <span>{hazardInfo[field]}</span>
      </div>
    ))
}

HazardousText.propTypes = {
  hazardInfo: PropTypes.shape({
    safetyInstructions: PropTypes.string,
    signalWord: PropTypes.string,
    warning: PropTypes.string
  }).isRequired,
  translationMapping: PropTypes.shape({
    safetyInstructions: PropTypes.string,
    signalWord: PropTypes.string,
    warning: PropTypes.string
  }).isRequired
}
export default HazardousText
